const Routes = {
    Default: "games",
	Games: "games",
	Music: "music",
	Repos: "repos"
}

export default Routes;